import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "subscription-container" }
const _hoisted_2 = {
  key: 0,
  class: "subscription-container__form"
}
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "subscription-container__content" }
const _hoisted_5 = { class: "subscription-container__content__chapter" }
const _hoisted_6 = { class: "subscription-container__content__items" }

import {onMounted, ref} from "vue";
import SubscriptionService from "@/ts/User/Service/SubscriptionService";
import FullPopup from "@/components/UI/Pupup/FullPopup.vue";
import AboutSubscriptionBlock from "@/components/User/Settings/Popup/AboutSubscription/AboutSubscriptionBlock.vue";
import CheckItem from "@/components/User/Settings/Popup/AboutSubscription/CheckItem.vue";
import UserService from "@/ts/User/Service/UserService";
import UserSubscription from "@/ts/User/Types/UserSubscription";
import AuthService from "@/ts/User/Service/AuthService";
import {useRouter} from "vue-router";



export default /*@__PURE__*/_defineComponent({
  __name: 'AboutSubscriptionPopup',
  setup(__props) {

const show = ref(false)
const cancelRecurrentLink = ref<string>( )
const subscription = ref<UserSubscription>()

const initCancelRecurrentLink = async () => {
  const url = new URL('https://sbsite.pro/stop_subs_1');
  const userId = await AuthService.getUserId();
  const profile = await UserService.getProfile();
  url.searchParams.append('email', profile.email);
  url.searchParams.append('id_pril', userId)
  cancelRecurrentLink.value = url.href;
}

onMounted(() => {
  const subscriptionService = SubscriptionService.getInstance()
  subscriptionService.addEventListener('showAbout', async () => {
    show.value = true
    subscription.value = await UserService.getSubscription()
    await initCancelRecurrentLink();
  })
})
const router = useRouter();
const openSupportChat = () => {
  window.open('https://online.muradyangames.com/tlgrm','_blank')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(FullPopup, {
    show: show.value,
    "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
    theme: "light",
    closed: "",
    padding: false,
    ref: "popup"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "subscription-container__preview" }, [
          _createElementVNode("div", { class: "subscription-container__preview__about" }, "О подписке")
        ], -1)),
        (subscription.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(AboutSubscriptionBlock, {
                "is-recurrent": subscription.value.isRecurrent,
                price: subscription.value.price,
                onSupport: openSupportChat,
                duration: subscription.value.durationInMonths,
                "expired-date": new Date(subscription.value.datePayment),
                card: subscription.value.cardLastFour
              }, null, 8, ["is-recurrent", "price", "duration", "expired-date", "card"]),
              (subscription.value.isRecurrent)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: cancelRecurrentLink.value,
                    target: "_blank",
                    class: "cancel-recurrent"
                  }, " Отменить автоматическое продление ", 8, _hoisted_3))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "subscription-container__content__title" }, "С подпиской PRO вы получаете полный доступ к уникальным инструментам для личностного роста и гармонизации жизни: ", -1)),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(CheckItem, null, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createTextVNode(" Новые медитации месяца уровня PRO")
                ])),
                _: 1
              }),
              _createVNode(CheckItem, null, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode(" 10 гениальных дневников для саморефлексии, работы с целями и желаниями и другими аспектами жизни ")
                ])),
                _: 1
              }),
              _createVNode(CheckItem, null, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createTextVNode(" Полная версия книги «Игра Атлантов. Алхимия мечты»")
                ])),
                _: 1
              }),
              _createVNode(CheckItem, null, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createTextVNode(" 4 колоды метафорических карт, которые помогут найти ответы на все вопросы")
                ])),
                _: 1
              }),
              _createVNode(CheckItem, null, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode(" 4 колоды метафорических карт, которые помогут найти ответы на все вопросы")
                ])),
                _: 1
              })
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})